










































    import { Component, Vue, Watch ,Prop} from 'vue-property-decorator';
    @Component(
        {
            components:{
            }
        }
    )
    export default class footPannel extends Vue {
        @Prop({
            default: ''
        })
        public type
        async mounted () {
        
        }
        openIcp() {
            window.open('https://beian.mps.gov.cn/#/query/webSearch', '_blank');
        }
        
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/components/fooTer.vue